import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  position: "relative",
  willChange: "width",
  justifySelf: "center",
}

export const iconBox: SxStyleProp = {
  position: "absolute",
  top: 0,
  right: 0,
  width: theme => theme.forms.input.height,
  height: theme => theme.forms.input.height,
  display: "grid",
  placeItems: "center",
}

export const input: SxStyleProp = {
  pr: theme => theme.forms.input.height,
  outline: "none",
  bg: "gray200",
  borderColor: "transparent",
}
